import { render, staticRenderFns } from "./Peugeot.vue?vue&type=template&id=4ad224b7&scoped=true&"
import script from "./Peugeot.vue?vue&type=script&lang=js&"
export * from "./Peugeot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad224b7",
  null
  
)

export default component.exports